<template>
  <div class="wrapper">
    <a-row :gutter="8">
      <a-col :span="6" class="gutter-row">
        <a-card title="运行概况" size="small" :bordered="false" style="width: 100%">
          <a-row :gutter="16" style="height: 102px; display: flex; align-items: center;">
            <a-col :span="12" style="text-align: center;">
              <a-statistic title="站所" :value="statInfo.process" style="margin-right: 50px">
                <template #suffix>
                  <a-icon type="bank" theme="filled" />
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="12" style="text-align: center;">
              <a-statistic title="电缆" :value="statInfo.dev" class="demo-class">
                <template #suffix>
                  <a-icon type="stock" />
                </template>
              </a-statistic>
            </a-col>
          </a-row>
          <div class="footer" style="margin-top: 15px; border-top: 1px solid #e8e8e8">
            <div style="height:40px;"></div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" class="gutter-row">
        <a-card>
          <a-row>
            <a-col :span="24">
              <chart-card :total="`${sensorOnlinePercent}%`" title="传感器在线率">
                <a-icon @click="handleToUrl('/sensor/list')" slot="action" type="info-circle" />
                <div flag="down">
                  <a-tag color="#87d068"> 在线： {{ online }} </a-tag>
                  <a-tag color="#ff4d4f"> 离线： {{ offline }} </a-tag>
                </div>
              </chart-card>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="6" class="gutter-row">
        <a-card>
          <a-row>
            <a-col :span="24">
              <chart-card :total="`${statInfo.alert}`" title="未恢复告警">
                <a-icon @click="handleToUrl('/alert/center')" slot="action" type="info-circle" />
                <div flag="down">
                  <a-icon type="bell" theme="filled" style="font-size: 36px;color: #ff4d4f;" />
                </div>
              </chart-card>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="6" class="gutter-row">
        <a-card>
          <a-row>
            <a-col :span="24">
              <chart-card :total="`${statInfo.defect}`" title="未处理缺陷">
                <a-icon @click="handleToUrl('/defect/defRegister')" slot="action" type="info-circle" />
                <div flag="down">
                  <a-icon type="tool" theme="filled" style="font-size: 36px;color: #1890FF;" />
                </div>
              </chart-card>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>

    <a-card size="small" title="告警日历">
      <a-button-group slot="extra">
        <a-button @click="changeYear(-1)">
          <a-icon type="left" />
        </a-button>
        <a-button :style="{ cursor: 'default' }" disabled>{{ year }}</a-button>
        <a-button @click="changeYear(1)">
          <a-icon type="right" />
        </a-button>
      </a-button-group>

      <v-chart :option="alarmCalendarOpts" style="width: 100%; height: 200px; background-color: #fff" />
    </a-card>

    <a-card size="small" title="告警分类">
      <a-radio-group @change="timeRangeChange" default-value="2" size="small" slot="extra" v-model="timeRange">
        <a-radio-button value="0">全部</a-radio-button>
        <a-radio-button value="1">去年</a-radio-button>
        <a-radio-button value="2">过去半年</a-radio-button>
        <a-radio-button value="3">今年</a-radio-button>
        <a-radio-button value="4">本月</a-radio-button>
      </a-radio-group>

      <a-row>
        <a-col :span="16">
          <v-chart :option="sixMonthslarmCountsBarOpts" style="width: 100%; height: 200px; background-color: #fff" />
        </a-col>
        <a-col :span="8">
          <v-chart :option="alarmModelsTop10Opts" style="width: 100%; height: 200px; background-color: #fff" />
        </a-col>
      </a-row>
    </a-card>

    <a-row :gutter="[8, 8]">
      <a-col :span="6" class="gutter-row">
        <a-card :bordered="false" title="本月告警统计">
          <template #extra>
            <a @click="handleToUrl('/alert/history')" href="javascript:;">历史告警</a>
          </template>
          <chart-card :total="alertTotal" title="已处理/未处理">
            <a-progress :percent="alertPercent" :successPercent="alertPercent" />
          </chart-card>
          <v-chart :option="alarmStatistics" ref="myChart" style="width: 100%; height: 235px; background-color: #fff" />
        </a-card>
      </a-col>
      <a-col :span="18" class="gutter-row">
        <a-card :bordered="false" title="未处理告警">
          <template #extra>
            <a @click="handleToUrl('/alert/center')" href="javascript:;">告警中心</a>
          </template>

          <grid-table :columns="columns" :queryParams="{ disposal: 0 }" ref="table" url="/alert/iotAlert/list">
            <template slot="htmlSlot" slot-scope="text">
              <div v-html="text"></div>
            </template>

            <template slot="fileSlot" slot-scope="text">
              <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
              <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
                >下载</a-button
              >
            </template>
            <span slot="levelSlot" slot-scope="alertLevel, item">
              <span v-if="item.alertLevel == 1">
                <a-tag color="#ff4d4f">紧急告警</a-tag>
              </span>
              <span v-else-if="item.alertLevel == 2">
                <a-tag color="#faad14">严重告警</a-tag>
              </span>
              <span v-else>
                <a-tag color="#52c41a">一般告警</a-tag>
              </span>
            </span>
            <span slot="recoverySlot" slot-scope="text, item">
              <a-tag color="#ff4d4f" v-if="item.isRecovery == 0">未恢复</a-tag>
              <a-tag color="#52c41a" v-else>已恢复</a-tag>
            </span>
          </grid-table>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="[8, 8]" style="margin-top: -20px">
      <a-card :bordered="false" title="设备故障">
        <template #extra>
          <a @click="handleToUrl('/defect/defRegister')" href="javascript:;">缺陷管理</a>
        </template>
        <grid-table
          :columns="defectColumns"
          :queryParams="{ defStatusStr: '0,1,2' }"
          ref="defectTable"
          url="/device/defRegister/list"
        >
          <span slot="defType" slot-scope="defType, record">
            <span v-if="record.defType == 1">
              <a-tag>设备类型</a-tag>
            </span>
            <span v-else-if="record.defType == 2">
              <a-tag>非设备类型</a-tag>
            </span>
          </span>
          <span slot="defLevel" slot-scope="priority, record">
            <a-tag :color="$filterDictTextByCache('def_level_color', record.defLevel)">{{
              record.defLevel_dictText
            }}</a-tag>
          </span>
        </grid-table>
      </a-card>
    </a-row>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import moment from 'dayjs'
import { RawTimeToTime } from '@/utils/TimeRangeUtils'

import { use } from 'echarts/core'
import { LegendComponent, VisualMapComponent, TitleComponent, CalendarComponent } from 'echarts/components'
import { LineChart, HeatmapChart, PieChart } from 'echarts/charts'
import VChart from 'vue-echarts'
use([LineChart, HeatmapChart, PieChart, LegendComponent, VisualMapComponent, TitleComponent, CalendarComponent])

import '@/assets/less/TableExpand.less'
import ChartCard from '@/components/ChartCard'
import ACol from 'ant-design-vue/es/grid/Col'
import ATooltip from 'ant-design-vue/es/tooltip/Tooltip'
import MiniProgress from '@/components/chart/MiniProgress'
import Bar from '@/components/chart/Bar'
import GridTable from '@/views/workbench/components/Itable.vue'
import { validatenull, validatenotnull } from '@/utils/validate'

export default {
  name: 'Overview',
  components: {
    GridTable,
    ATooltip,
    ACol,
    ChartCard,
    MiniProgress,
    Bar,
    VChart
  },
  data() {
    const forceNowrap = text => <span class="j-force-nowrap">{text}</span>
    return {
      url: {
        getOverview: '/plant/dashboard/countStat',
        sensorList: '/monitor/sensor/gislist',

        getAlarmModelsTopN: '/alert/iotAlert/modelCount',
        getAlarmMonthCount: '/alert/iotAlert/monthCount',
        getAlarmYearCount: '/alert/iotAlert/yearCount',

        maintainceStat: '/maintenance/devMaintainceTask/stat',
        iotAlertListUrl: '/alert/iotAlert/list',
        iotAlertPlantStatisticsUrl: '/alert/iotAlert/getIotAlertPlantStatistics',
        devUptimeRateUrl: '/device/devList/getDevUptimeRate',
        getReportUrl: '/custom/commonOnlReport/list'
      },
      statInfo: { process: 0, dev: 0, alert: 0, defect: 0 },
      online: 0,
      offline: 0,
      sensorOnlinePercent: 100,
      sixMonthslarmCountsBarOpts: {},
      alarmModelsTop10Opts: {},
      timeRange: '2',
      year: 2023,
      alarmCalendarOpts: {},

      maintaince: {
        total: 0,
        percent: 100
      },
      alarmStatistics: {},
      // 表头
      columns: [
        {
          title: '告警描述',
          align: 'center',
          dataIndex: 'summary',
          width: '50%',
          align: 'left'
        },
        {
          title: '告警时间',
          align: 'center',
          dataIndex: 'alertTime',
          customRender: forceNowrap
        },
        {
          title: '告警级别',
          align: 'center',
          dataIndex: 'alertLevel_dictText',
          scopedSlots: { customRender: 'levelSlot' }
        },
        {
          title: '告警来源',
          align: 'center',
          dataIndex: 'alertType_dictText',
          customRender: forceNowrap
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'isRecovery',
          scopedSlots: { customRender: 'recoverySlot' }
        }
      ],
      defectColumns: [
        {
          title: '设备名称',
          align: 'center',
          dataIndex: 'devName',
          sorter: true
        },
        {
          title: '缺陷内容',
          align: 'center',
          dataIndex: 'defContent'
        },
        {
          title: '缺陷部位',
          align: 'center',
          dataIndex: 'defPart'
        },
        {
          title: '缺陷类别',
          align: 'center',
          dataIndex: 'defCategory',
          sorter: true
        },
        {
          title: '缺陷等级',
          align: 'center',
          dataIndex: 'defLevel',
          scopedSlots: { customRender: 'defLevel' },
          sorter: true
        },
        {
          title: '缺陷发现人',
          align: 'center',
          dataIndex: 'defInventor_dictText',
          scopedSlots: { customRender: 'defInventor' }
        },
        {
          title: '缺陷发现时间',
          align: 'center',
          dataIndex: 'defFindTime',
          width: 180,
          sorter: true
        },
        {
          title: '当前状态',
          align: 'center',
          dataIndex: 'defStatus_dictText',
          sorter: true
        }
      ],
      alertTotal: '0/0',
      alertPercent: 0,
      devUptimeRate: 100,
      reportUrl: {}
    }
  },
  created() {
    this.year = moment().year()
    this.changeYear(0)
    this.getAlarmMonthCount()
    this.timeRangeChange()

    this.getMaintainceStat()
    this.getIotAlertPlantStatistics()
    this.getDevUptimeRate()

    this.getOverview()
    this.getSensorList()

    const that = this
    getAction(this.url.getReportUrl, { reportGroup: 'drill-ana' }).then(res => {
      if (res.success && res.result) {
        res.result.records.forEach(rep => {
          that.reportUrl[rep.shortName] = rep.url
        })
      }
    })
  },
  methods: {
    getOverview() {
      getAction(this.url.getOverview, {}).then(res => {
        if (res.success) {
          this.statInfo = Object.assign(this.statInfo, res.result)
        }
      })
    },
    getSensorList() {
      getAction(this.url.sensorList).then(res => {
        if (res.result.length > 0) {
          const total = res.result.length
          this.offline = res.result.filter(sensor => sensor.runningStatus === 'Offline').length
          this.online = total - this.offline
          this.sensorOnlinePercent = total === 0 ? 100 : ((100 * (total - this.offline)) / total).toFixed(2)
        }
      })
    },
    timeRangeChange() {
      this.getAlarmModelsTopN()
    },
    getAlarmModelsTopN() {
      const { startTime, endTime } = this.getTime()
      getAction(this.url.getAlarmModelsTopN, { n: 10, startTime, endTime }).then(res => {
        if (res.success) {
          const result = res.result
          const xAxis = []
          const level1 = [],
            level2 = [],
            level3 = []

          result.forEach(m => {
            xAxis.push(m.dev_name)
            level1.push(m.level1 || 0)
            level2.push(m.level2 || 0)
            level3.push(m.level3 || 0)
          })

          this.alarmModelsTop10Opts = {
            grid: {
              top: 20,
              bottom: 20,
              left: 100,
              right: 40
            },
            tooltip: {
              trigger: 'axis'
            },
            yAxis: {
              type: 'category',
              data: xAxis,
              inverse: true,
              axisLabel: {
                interval: 0
              }
            },
            xAxis: {
              type: 'value'
            },
            series: [
              {
                data: level1,
                name: '紧急告警',
                type: 'bar',
                barMaxWidth: 50,
                stack: '总计',
                itemStyle: {
                  color: '#ff4d4f'
                }
              },
              {
                data: level2,
                name: '严重告警',
                type: 'bar',
                barMaxWidth: 50,
                stack: '总计',
                itemStyle: {
                  color: '#faad14'
                }
              },
              {
                data: level3,
                name: '一般告警',
                type: 'bar',
                barMaxWidth: 50,
                stack: '总计',
                itemStyle: {
                  color: '#52c41a'
                }
              }
            ]
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getAlarmMonthCount() {
      getAction(this.url.getAlarmMonthCount, { months: 6 }).then(res => {
        if (res.success) {
          const result = res.result.reverse()
          const xAxis = []
          const level1 = [],
            level2 = [],
            level3 = []

          result.forEach(m => {
            xAxis.push(m.yyyymm)
            level1.push(m.level1 || 0)
            level2.push(m.level2 || 0)
            level3.push(m.level3 || 0)
          })

          this.sixMonthslarmCountsBarOpts = {
            grid: {
              top: 20,
              bottom: 20,
              left: 30,
              right: 40
            },
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: xAxis,
              axisLabel: {
                interval: 0
              }
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                data: level1,
                name: '紧急告警',
                type: 'bar',
                barMaxWidth: 50,
                stack: '总计',
                itemStyle: {
                  color: '#ff4d4f'
                }
              },
              {
                data: level2,
                name: '严重告警',
                type: 'bar',
                barMaxWidth: 50,
                stack: '总计',
                itemStyle: {
                  color: '#faad14'
                }
              },
              {
                data: level3,
                name: '一般告警',
                type: 'bar',
                barMaxWidth: 50,
                stack: '总计',
                itemStyle: {
                  color: '#52c41a'
                }
              }
            ]
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getTime() {
      let startTime, endTime
      const formatter = 'YYYY-MM-DD HH:mm:ss'
      if (this.timeRange === '1') {
        startTime = RawTimeToTime('now-1y/y', { end: 'from', format: formatter })
        endTime = RawTimeToTime('now-1y/y', { end: 'to', format: formatter })
      } else if (this.timeRange === '2') {
        startTime = RawTimeToTime('now-6M', { end: 'from', format: formatter })
        endTime = RawTimeToTime('now', { end: 'to', format: formatter })
      } else if (this.timeRange === '3') {
        startTime = RawTimeToTime('now/y', { end: 'from', format: formatter })
        endTime = RawTimeToTime('now/y', { end: 'to', format: formatter })
      } else if (this.timeRange === '4') {
        startTime = RawTimeToTime('now/M', { end: 'from', format: formatter })
        endTime = RawTimeToTime('now/M', { end: 'to', format: formatter })
      }
      return { startTime, endTime }
    },
    changeYear(change) {
      const thisYear = moment().year()
      if (change === 1 && this.year === thisYear) {
        return
      }
      if (change === -1 && this.year === 1970) {
        return
      }
      this.year += change
      getAction(this.url.getAlarmYearCount, { year: this.year }).then(res => {
        if (res.success) {
          const result = res.result
          let max = 0
          const calendarData = []
          result.forEach(item => {
            calendarData.push([item.yyyymmdd, item.count])
            if (item.count > max) {
              max = item.count
            }
          })

          this.alarmCalendarOpts = {
            tooltip: {
              formatter: '{c}'
            },
            visualMap: {
              min: 0,
              max: max,
              calculable: true,
              orient: 'horizontal',
              left: 'center'
            },
            calendar: {
              top: 50,
              left: 30,
              right: 30,
              cellSize: ['auto', 13],
              range: this.year,
              itemStyle: {
                borderWidth: 0.5
              },
              yearLabel: { show: false }
            },
            series: {
              type: 'heatmap',
              coordinateSystem: 'calendar',
              data: calendarData
            }
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getMaintainceStat() {
      getAction(this.url.maintainceStat, {}).then(res => {
        if (res.success) {
          const stat = res.result
          this.maintaince.total = stat.total + ''
          if (stat.total - 0 > 0) {
            this.maintaince.percent = parseFloat(((stat.finished * 100) / stat.total).toFixed(1))
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getDevUptimeRate() {
      getAction(this.url.devUptimeRateUrl, {}).then(res => {
        if (res.success) {
          this.devUptimeRate = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getAlarmStatistics(data) {
      //总数+计算百分比
      ;(this.alertTotal =
        (validatenotnull(data.processedCount) ? data.processedCount : 0) +
        '/' +
        (validatenotnull(data.untreatedCount) ? data.untreatedCount : 0)),
        (this.alertPercent = Number(
          data.alertCount == 0 ? 0 : ((data.processedCount / data.alertCount) * 100).toFixed(2)
        ))
      //封装警告数据
      const result = []
      if (validatenotnull(data.alertLevelMap)) {
        for (let key in data.alertLevelMap) {
          let obj = {}
          if (key == 1) {
            obj.name = '紧急告警'
          } else if (key == 2) {
            obj.name = '严重告警'
          } else if (key == 3) {
            obj.name = '一般告警'
          }
          obj.value = data.alertLevelMap[key]
          result.push(obj)
        }
      }
      const alarmCounts = validatenotnull(data.alertCount) ? data.alertCount : 0
      this.alarmStatistics = {
        title: {
          text: '告警总数', // 主标题
          textStyle: {
            // 主标题样式
            color: '#333',
            fontSize: 14
          },
          left: '49%', // 定位到适合的位置
          top: '41%', // 定位到适合的位置
          x: 'center',
          y: 'center',
          subtext: alarmCounts, // 副标题
          subtextStyle: {
            // 副标题样式
            color: 'red',
            fontSize: 13,
            fontWeight: 'bold'
          },
          textAlign: 'center' // 主、副标题水平居中显示
        },
        color: ['#ef6567', '#f9c956', '#5470c6'],
        series: [
          {
            type: 'pie',
            radius: [40, 60],
            data: result,
            label: {
              formatter: '{name|{b}}\n{time|{c}}',
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 12,
                  color: '#999'
                }
              }
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80
            },
            labelLayout: function(params) {
              const isLeft = params.labelRect.x < 200 / 2
              const points = params.labelLinePoints
              // Update the end point.
              points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width
              return {
                labelLinePoints: points
              }
            }
          }
        ]
      }
    },

    getIotAlertPlantStatistics() {
      //传入月份第一天和最后一天
      const firstDay =
        moment()
          .startOf('month')
          .format('YYYY-MM-DD') + ' 00:00:00'
      getAction(this.url.iotAlertPlantStatisticsUrl, Object.assign({ alertTime_begin: firstDay })).then(res => {
        if (res.success) {
          if (validatenotnull(res.result)) {
            this.getAlarmStatistics(res.result)
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleToUrl(url, params) {
      if (validatenull(url)) {
        return
      }
      this.$router.push({ path: url, query: params })
    },
    showStatReport(record, reportKey, key, paramKey) {
      let url = this.reportUrl[reportKey]
      if (!url) {
        this.$message.warning('未找到统计信息配置')
      }
      if (key) {
        if (url.indexOf(`${paramKey}`) > -1) {
          url = url.replace(`\$\{${paramKey}\}`, record[key])
        } else {
          url += `&${paramKey}=${record[key]}`
        }
      }
      url = url.replace('${tenant_id}', this.$ls.get('TENANT_ID'))
      this.$refs['iframeDrawer'].show(url)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  padding: 8px;
  .ant-card-body {
    padding: 0px 24px;
  }
  .ant-card {
    margin-bottom: 10px;
  }
}
.ant-card-bordered {
  border: 1px solid #d9d9d9;
}

/deep/ .gutter-row .ant-statistic-content {
  font-size: 36px;
}

/deep/ .gutter-row .ant-statistic-content-suffix {
  font-size: 28px;
}
</style>
